export default __webpack_public_path__ + "static/media/googleBlack.4822bfa0.svg";